module.exports = __webpack_public_path__ + "img/popup-bg-bottom.131e602.png";